import React from 'react';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import { regionLocale } from 'src/app/i18n';

interface tableConfigType {
  title: string;
  prop: string;
  align?: any;
  render?: any;
  minWidth?: number;
  sorter?: boolean | false;
}

const getPropFromI18nData = (locale: string, row: any, prop: string) => {
  const data = row?.i18nData?.find((item: any) => {
    // return item.lang === locale;
    return item.locale === locale;
  });

  return data?.[prop];
};
const i18ConfigData = regionLocale;

const tableConfig = (Translation: any, locale: any): tableConfigType[] => {
  if (i18ConfigData.length === 0) {
    return [];
  }

  const i18nColumns = i18ConfigData.map((lang) => ({
    title: `${Translation('component.formLabel.category')} (${Translation(`navBar.lang.${lang}`)})`,
    prop: `i18n_name_${lang}`,
    sorter: true,
    render: (row: any) => <span>{getPropFromI18nData(lang, row, 'name')}</span>,
  }));

  return [
    ...i18nColumns,
    {
      title: Translation('title.event.category.table.header.description'),
      prop: 'description',
    },
    {
      title: Translation('title.event.category.table.header.weight'),
      prop: 'weight',
      sorter: true,
    },
    {
      title: Translation('title.event.category.table.header.status'),
      sorter: true,
      prop: 'status',
      render: (row: any) => (
        <span>
          {row.status === 'active'
            ? Translation('component.formSelectItem.active')
            : Translation('component.formSelectItem.inactive')}
        </span>
      ),
    },
    {
      title: Translation('component.formLabel.last-updated-time'),
      sorter: true,
      // prop: 'modifyTime',
      prop: 'updatedAt',
      render: (row: any) => <span>{getDefaultDisplayDate(row.updatedAt, 'datetime')}</span>,
    },
    {
      title: Translation('component.formLabel.last-updated-by'),
      prop: 'updatedBy',
      render: (row: any) => <span>{row.updatedBy || row.createdBy}</span>,
    },
  ];
};

export default tableConfig;
